import type { ProductCharacteristic, ProductCharacteristics } from '#sitis/internal/controllers/products/models/Product';
import type { IWishCharacteristics } from '#sitis/internal/controllers/wish/models/WishlistItem';

interface ICharString {
    value: string;
    slug: string
}

export interface IList {
    unit: string | undefined;
    id: number,
    name: string,
    nameForProduct?: string,
    value: ICharString[]
}

type filterCharsType = string | 'showInFilter' | 'showInProduct' | 'showInProductCard';

export const charactersParser = (
  characteristics: ProductCharacteristics[] | IWishCharacteristics[] | undefined,
  filterCharStr: filterCharsType = 'showInFilter'
) => {
  const list: Record<string, any> = {};

  const char = characteristics?.[0]?.characteristics ?? [];

  char.forEach(({
    values,
    slug,
    showInProductCard,
    showInProduct,
    showInFilter
  }) => {
    if ((filterCharStr === 'showInProduct' && showInProduct) ||
            (filterCharStr === 'showInFilter' && showInFilter) ||
            (filterCharStr === 'showInProductCard' && showInProductCard)) {
      list[slug] = values?.[0]?.value;
    }
  });

  return list;
};
